module.exports = __webpack_public_path__ + "img/evo-sokolniki.d1492c28.png";